import { csv } from "d3-fetch";
import STUDENTS_RACE from "../data/passhe-students-race-2008-to-2012.csv";

const loadData = () => {
  /* Fetch and parse files. */
  return Promise.all([csv(STUDENTS_RACE)]).then(([studentsRace]) => {
    const data = {};

    data.studentsRace = studentsRace;
    return data;
  });
};

export default loadData;
